import { LoadingController } from 'ionic-angular/components/loading/loading-controller';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { SPHLoggedInUser } from './../../shared/model/sph-logged-in-user.model';
import { LicenseManagerService } from './../../shared/licensemanager-service/licensemanager.service';
import { CompanyDetailsComponent } from './../companyDetailsComponent/company-details.component';
import { SPHCompany } from './../../shared/model/sph-company.model';
import { Component, OnInit, Input } from '@angular/core';
import { NavController, ModalController, PopoverController } from 'ionic-angular';
import { AddCompanyComponent, SelectComponent } from '../companyLicenseManagement';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { AlertController } from 'ionic-angular/components/alert/alert-controller';

@Component({
    selector: 'lm-companies',
    templateUrl: 'companies.component.html'
})
export class CompaniesComponent implements OnInit {
    public options = [
        {title: 'Nicht begrenzen', value: 'all'},
        {title: 'Firmenname', value: 'name'},
        {title: 'Anschrift', value: 'location'},
        {title: 'Kd.Nr.', value: 'identnr'},
    ];

    private _user: SPHLoggedInUser;
    @Input() set user(user: SPHLoggedInUser) {
        this._user = user;
        if (user !== undefined && user !== null) {
            this.reloadCompanies(user);
        }
    }
    get user(): SPHLoggedInUser {
        return this._user;
    }
    private limitSearch = 'all';

    private get limitSearchDisplayText(): string {
        switch (this.limitSearch) {
            case 'all':
                return 'Suche nicht begrenzen';
            case 'name':
                return 'Firmenname';
            case 'location':
                return 'Anschrift';
            case 'identnr':
                return 'Kd.Nr.';
        }
    }

    private _searchText: string = '';
    private set searchText(text: string) {
        this._searchText = text;
    }

    private get searchText() {
        return this._searchText;
    }

    private sortBy: string = 'identnr';
    private sortAsc: boolean = true;

    private displayedCompanies: SPHCompany[] = [];

    private _companies: SPHCompany[] = [];

    public set companies(companies: SPHCompany[]) {
        this._companies = companies;
        this.updateDisplayedCompanies(companies, this.searchText, this.limitSearch, this.sortBy, this.sortAsc);
    }

    public get companies(): SPHCompany[] {
        return this._companies;
    }

    constructor(private navController: NavController, private licenseManagerService: LicenseManagerService, private navParams: NavParams, private modalController: ModalController, private loadingController: LoadingController, private toastController: ToastController, private alertController: AlertController, private popoverController: PopoverController) {
    }

    public ionViewDidEnter() {
        if (this.user !== undefined && this.user !== null) {
            this.reloadCompanies(this.user);
        }
    }

    public ngOnInit() {
        this.user = this.navParams.get('user');
    }

    public searchTextInputChanged(searchText: string, searchLimitedTo: string) {
        this.searchText = searchText;
        this.updateDisplayedCompanies(this.companies, searchText, searchLimitedTo, this.sortBy, this.sortAsc);
    }

    public filterSelectTapped(event) {
        const popover = this.popoverController.create(SelectComponent, {options: this.options, title: 'Suche begrenzen auf...' });
        popover.present({ev: event});

        popover.onDidDismiss( (data) => {
            if (data) {
                this.limitSearch = data.value;
                this.updateDisplayedCompanies(this.companies, this.searchText, this.limitSearch, this.sortBy, this.sortAsc);
            }
        } );
    }

    public didTapRowHeader(sortableString: string) {
        if (sortableString === this.sortBy) {
            this.sortAsc = !this.sortAsc;
        } else {
            this.sortBy = sortableString;
            this.sortAsc = true;
        }
        this.updateDisplayedCompanies(this.companies, this.searchText, this.limitSearch, this.sortBy, this.sortAsc);
    }

    public didTapAddCompany() {
        const addModal = this.modalController.create(AddCompanyComponent, { user: this.user }, { enableBackdropDismiss: false });
        addModal.onDidDismiss(() => {
            setTimeout( () => { this.reloadCompanies(this.user); }, 500);
        });
        addModal.present();
    }

    public didTapCompany(company: SPHCompany) {
        this.navController.push(CompanyDetailsComponent, { company, user: this.user });
    }

    public didTapDeleteCompany(company: SPHCompany) {

        const alert = this.alertController.create({
            title: 'Firma löschen?',
            message: 'Soll die Firma \'' + company.name + '\' wirklich gelöscht werden?',
            buttons: [
                {
                    text: 'Abbrechen',
                    role: 'cancel',
                },
                {
                    text: 'Löschen',
                    handler: () => {
                        this.licenseManagerService.deleteCompany(company.id, this.user.jwt).subscribe((success) => {
                            setTimeout( () => { this.reloadCompanies(this.user); }, 500);
                        });
                    }
                }
            ]
        });
        alert.present();

    }

    private reloadCompanies(user: SPHLoggedInUser) {

        this.licenseManagerService.getCompanies(user.jwt).subscribe((companies) => {
            this.companies = companies;
        }, (error) => {
            const toast = this.toastController.create({ message: error.message, duration: 3000 });
            toast.present();
        }, () => {
            console.debug('observable completed!!!');
        });
    }

    private updateDisplayedCompanies(companies: SPHCompany[], searchText: string, scope: string, sorting: string, asc: boolean) {
        this.displayedCompanies = companies
            .filter(this.filterFunctionFrom(searchText, scope))
            .sort((a: SPHCompany, b: SPHCompany) => {
                if (a[sorting] < b[sorting]) {
                    return asc ? -1 : 1;
                } else if (a[sorting] > b[sorting]) {
                    return asc ? 1 : -1;
                }
                return 0;
            });
    }

    private filterFunctionFrom(text: string, scope: string) {
        if (text === '' || text === undefined) {
            return () => true;
        } else {
            text = text.toLowerCase();
            return (company: SPHCompany) => {
                if (scope === 'all') {
                    return (company.name !== undefined && company.name.toLowerCase().includes(text)) || (company.location !== undefined && company.location.toLowerCase().includes(text)) || (company.identnr !== undefined && company.identnr.includes(text));
                } else {
                    return company[scope] !== undefined && company[scope].toLowerCase().includes(text);
                }
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/companiesComponent/companies.component.ts